export default __webpack_public_path__ + "static/media/CA_01.48976e89.png";